import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { consultasStockApi } from '../api/consultasStock'
import { colors, font } from '../design/tokens'
import MovilConsultaStock from './movil/MovilConsultaStock'
import { Cargando } from './movil/comunes'

// Link del Telegram de depósito (/deposito/consulta-stock/:token). Si el
// celular ya tiene sesión en LGR, pasa a la versión móvil con esa sesión; si
// no, responde por el token (sirve solo para esta consulta, hasta 24 h).
export default function DepositoConsultaStockPage() {
  const { token } = useParams()
  const navigate = useNavigate()
  const conSesion = (() => { try { return !!localStorage.getItem('lgr_token') } catch { return false } })()
  const [listo, setListo] = useState(!conSesion)

  useEffect(() => {
    if (!conSesion) return
    consultasStockApi.verPorToken(token)
      .then(({ data }) => navigate(`/m/consultas-stock/${data.consulta.id}`, { replace: true }))
      .catch(() => setListo(true))
  }, [conSesion, token, navigate])

  return (
    <div style={{ minHeight: '100vh', background: colors.bgSoft, fontFamily: font.sans }}>
      <header style={{ background: colors.bg, borderBottom: `1px solid ${colors.border}`, padding: '12px 14px', fontWeight: 700, fontSize: 15, color: colors.text }}>
        LGR · Depósito
      </header>
      <div style={{ maxWidth: 560, margin: '0 auto', padding: 12 }}>
        {listo ? <MovilConsultaStock token={token} /> : <Cargando />}
      </div>
    </div>
  )
}
